module.exports = {
	"articleTitle1": "Live Action Oscar Shorts paints a vibrant Europe ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "LIVE",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/live-night-review",
	"articleSnippet1": "Feb 14, 2017 ... Seen together, this year's crop of Oscar contenders for the Live Action Short paint \na diverse picture of life across the European continent.",
	"articleSnippet2": "Jan 16, 2017 ... “Live by Night,” the latest film from writer-director-actor Ben Affleck (“Argo”), \nstumbles in its opening minute. In a sepia montage of his World War ...",
	"foodRecommendations": [
		{
			"text": "Come for Candy Bar every Thurday night, a religious experience. No actual candy though.",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "'Live by Night' trades clarity for beauty ",
	"address": "102 S 1st St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/pau.BarOpeningOnline.jpg",
			"author": "Paul Sherman",
			"caption": "Owners Paul Drennan , Adam Lowenstein, Robbie Schulz, and Justin Herrick stand outside of their new bar LIVE, which is set to open on February 3"
		}
	],
	"position": {
		"lat": 42.2813,
		"lng": -83.7513
	},
	"totalMisc": 0,
	"categories": {
		"nightlife": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/livebar.json
// module id = 908
// module chunks = 0